module.exports = __webpack_public_path__ + "front/img/u1.ef7621dd.jpg";